export default __webpack_public_path__ + "static/media/worsell-manor-welcome.4a587ee3.jpg";